import { automationWorkflowsApi } from 'store/api';
import { apiSlice } from './apiSlice';
import { createSafeQueryFn } from './utils/queries';
import { IAutomationWorkflow, IFindAutomationWorkflowsParams } from 'api/digifi/AutomationWorkflowsApi';

export const automationWorkflowsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    findAutomationWorkflows: builder.query<
      IAutomationWorkflow[],
      IFindAutomationWorkflowsParams
    >({
      queryFn: createSafeQueryFn(async (params) => {
        return automationWorkflowsApi.find(params);
      }),
    }),
  }),
});

export const { useFindAutomationWorkflowsQuery } = automationWorkflowsSlice;
